import Http from '@/utils/Http'

export default {
  get(route, params = {}, config) {
    return Http.get({ path: route, params }, config).then(response => response, (error) => {
      // response.result 为null的时候, 返回response
      throw (error)
    })
  },
  post(route, params = {}, config) {
    return Http.post({ path: route, params }, config).then(response => response, (error) => {
      throw (error)
    })
  },
  bodyPost(route, data = {}, config) {
    return Http.post({ path: route, data }, config).then(response => response, (error) => {
      throw (error)
    })
  },
  getJson(route, params = {}, config) {
    return Http.get({ path: `${process.env.VUE_APP_JSON_HOST}${route}`, params }, config).then(response => response, (error) => {
      throw (error)
    })
  },


}
